import { StickerGridTemplateFactory } from './StickerGridTemplateFactory';

export class StickerGridTemplate3657 extends StickerGridTemplateFactory {
  constructor(emptyStickers) {
    super(
      emptyStickers,
      4,
      10,
      {
        top: 21.5,
        left: 10.2,
      },
      {
        external: {
          horizontal: 0,
          vertical: 0,
        },
        internal: {
          qrLeft: 3,
          qrRight: 0,
          qrTop: 5,
          qrBot: 5,
          label: 1,
          labelTop: 3,
        },
      },
      {
        qr: 15.4,
        labelV: 6.9,
        labelH: 27.6,
        font: 9,
      },
      {
        orientation: 'p',
        unit: 'mm',
        format: 'a4',
      }
    );
  }

  getStickerTotalXSize =
    this.pad.internal.qrLeft +
    this.size.qr +
    this.pad.internal.qrRight +
    this.pad.internal.label +
    this.size.labelH +
    this.pad.internal.label;

  getStickerTotalYSize = this.pad.internal.qrTop + this.size.qr + this.pad.internal.qrBot;

  static getConstructorFunction = emptyStickers => new StickerGridTemplate3657(emptyStickers);
}
